module.exports = qrcode;